module.exports = __webpack_public_path__ + "img/offer-detail-logo.b55c79bd.png";